import { FC, useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { Field, useFormState, type FieldInputProps } from 'react-final-form';
import Label from 'src/common/components/Label';
import NumberInput from 'src/common/components/NumberInput';
import { ADULTS, type BookNowDirectFormState } from 'src/book-now-direct/constants';
import { useBookNowDirectContext } from 'src/book-now-direct/providers/BookNowDirectProvider';
import styles from './GuestField.module.scss';

const GuestField: FC = () => {
  const [t] = useTranslation('book-now');
  const { listing: { capacity }, fetchAndUpdateInstabooksOnDate } = useBookNowDirectContext();
  const { values: { departDate } } = useFormState<BookNowDirectFormState>();

  const onChange = useCallback((
    input: FieldInputProps<number, HTMLElement>,
  ) => (value: number) => {
    input.onChange(value);
    if (departDate) {
      // guest count could change addon pricing, refetch instabooks
      fetchAndUpdateInstabooksOnDate(departDate, value);
    }
  }, [departDate, fetchAndUpdateInstabooksOnDate]);

  return (
    <div>
      <Field name={ADULTS}>
        {({ input, meta }) => (
          <div className={styles.root}>
            <Label
              htmlFor={ADULTS}
              label={t('book-now--form-group-size-label')}
              inlineSlot={t('book-now--max-capacity', { capacity })}
              size="m"
            />
            <NumberInput
              min={1}
              max={capacity}
              value={input.value}
              onChange={onChange(input)}
              onBlur={input.onBlur}
              size="l"
              error={meta.submitFailed && meta.error}
            />
          </div>
        )}
      </Field>
    </div>
  );
};

export default GuestField;
